/* covered.ro — FAQ accordion: smooth height on native <details>. */
(() => {
  if (customElements.get('cv-faq')) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class CvFaq extends HTMLElement {
    connectedCallback() {
      this.onClick = this.onClick.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.addEventListener('click', this.onClick);
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      this.items.forEach((item) => item.classList.toggle('is-open', item.open));
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    get items() {
      return Array.from(this.querySelectorAll(':scope > details'));
    }

    get canAnimate() {
      return (
        !reduceMotion.matches &&
        !document.body.classList.contains('disable-animations') &&
        typeof Element.prototype.animate === 'function'
      );
    }

    isOpen(item) {
      return item.open && !item.classList.contains('is-closing');
    }

    onClick(event) {
      const summary = event.target.closest('summary');
      if (!summary || !summary.parentElement || summary.parentElement.parentElement !== this) return;
      event.preventDefault();
      const item = summary.parentElement;
      this.toggle(item, !this.isOpen(item));
    }

    onBlockSelect(event) {
      const item = event.target.closest('details');
      if (item && !this.isOpen(item)) this.toggle(item, true, true);
    }

    toggle(item, open, instant = false) {
      if (open && this.hasAttribute('data-single')) {
        this.items.forEach((other) => {
          if (other !== item && this.isOpen(other)) this.toggle(other, false, instant);
        });
      }

      const panel = item.querySelector('.cv-faq__panel');
      const current = panel ? panel.getBoundingClientRect().height : 0;
      if (item._cvAnim) {
        item._cvAnim.onfinish = null;
        item._cvAnim.cancel();
        item._cvAnim = null;
      }

      item.classList.toggle('is-open', open);
      item.classList.remove('is-closing');

      if (!panel || instant || !this.canAnimate) {
        item.open = open;
        return;
      }

      if (open) {
        const from = item.open ? current : 0;
        item.open = true;
        const to = panel.scrollHeight;
        item._cvAnim = panel.animate(
          [
            { height: `${from}px`, opacity: from ? 1 : 0 },
            { height: `${to}px`, opacity: 1 },
          ],
          { duration: 480, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }
        );
        item._cvAnim.onfinish = () => {
          item._cvAnim = null;
        };
      } else {
        item.classList.add('is-closing');
        item._cvAnim = panel.animate(
          [
            { height: `${current}px`, opacity: 1 },
            { height: '0px', opacity: 0 },
          ],
          { duration: 320, easing: 'cubic-bezier(0.65, 0, 0.35, 1)' }
        );
        item._cvAnim.onfinish = () => {
          item._cvAnim = null;
          item.open = false;
          item.classList.remove('is-closing');
        };
      }
    }
  }

  customElements.define('cv-faq', CvFaq);
})();
